export default "__VITE_ASSET__2edf1da8__"